/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Focus_FilterInputs */

const en_cmd_focus_filter = /** @type {(inputs: Cmd_Focus_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter items`)
};

const de_cmd_focus_filter = /** @type {(inputs: Cmd_Focus_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgänge filtern`)
};

/**
* | output |
* | --- |
* | "Filter items" |
*
* @param {Cmd_Focus_FilterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_focus_filter = /** @type {((inputs?: Cmd_Focus_FilterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Focus_FilterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_focus_filter(inputs)
	return en_cmd_focus_filter(inputs)
});